<!--
   Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
-->

@if (uploadProgressInPercents !== null) {
  <div class="drop-area" gta="dialog-contact-us__drop-area">
    <span>Uploading… {{ uploadProgressInPercents }}%</span>
    <mat-progress-bar mode="determinate" [value]="uploadProgressInPercents"></mat-progress-bar>
  </div>
} @else {
  <label
    class="drop-area"
    [ngClass]="{ dragover: dragOver }"
    (dragover)="onDragover($event)"
    (dragleave)="onDragleave($event)"
    (drop)="onDrop($event)"
    gta="dialog-contact-us__drop-area"
  >
    <span>Drop files here or</span>
    <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">Open file</button>
    <input type="file" #fileInput multiple="true" name="files" (change)="onFileInputChange($event)" />
  </label>
}
